import FormField from '@berlitz/form-field'
import { IMaxInput } from '@components/Input/max/interface'
import React from 'react'
import Input from './max'
import { StyledInput, StyledLabel } from './style'

type FormFieldProps = React.ComponentProps<typeof FormField>

interface MyFormValues {
  name: string
}

interface FieldInputProps extends IMaxInput, FormFieldProps {
  field?: MyFormValues
  warning?: boolean
  error?: boolean
  formField?: boolean
}

const CustomInput: React.FunctionComponent<FieldInputProps> = ({
  ariaDescribedby,
  autocomplete,
  button,
  defaultValue,
  disabled,
  ghost,
  id,
  invalid,
  maxLength,
  minLength,
  name,
  onChange,
  placeholder,
  required,
  type,
  field,
  warning,
  error,
  label,
  value,
  onKeyDown,
  onKeyPress,
  onKeyUp,
  validationMessage,
  validationMessageLeft,
  formField,
}) => {
  let fieldName = name
  if (field && field.name) {
    fieldName = field.name
  }

  const inputProps = {
    ariaDescribedby,
    autoComplete: autocomplete,
    button,
    defaultValue,
    disabled,
    ghost,
    id,
    invalid,
    maxLength,
    minLength,
    name: fieldName,
    onChange,
    placeholder,
    required,
    type,
    value,
    onKeyDown,
    onKeyPress,
    onKeyUp,
  }
  const inputBody = formField ? (
    <FormField
      label=""
      invalid={invalid}
      validationMessage={validationMessage}
      validationMessageLeft={validationMessageLeft}
    >
      <Input {...inputProps} />
    </FormField>
  ) : (
    <Input {...inputProps} />
  )
  return (
    <StyledInput warning={warning} error={error}>
      {label ? <StyledLabel>{label}</StyledLabel> : null}
      {inputBody}
    </StyledInput>
  )
}

CustomInput.defaultProps = {
  type: 'text',
  name: '',
}

export default CustomInput
